import {
  Box,
  Form,
  Card,
  Divider,
  FormLayout,
  InlineGrid,
  Select,
  Text,
  TextField,
  BlockStack,
  useBreakpoints,
  Button,
  Checkbox,
  InlineStack,
  ContextualSaveBar,
  SkeletonBodyText,
  Thumbnail,
} from '@shopify/polaris';

import { useCallback, useEffect, useRef, useState } from 'react';
import helpers from 'helpers';

import { XIcon } from '@shopify/polaris-icons';
import { lengthLessThan, lengthMoreThan, notEmptyString, useField, useForm } from '@shopify/react-form';

import { TypedUser } from 'interface/user.model';
import MultiJob from 'components/multiJob';
import DateTimeInput from 'components/dateTimeInput';
import __ from 'languages/index';
import { useAddUserToJob } from 'queries/user.query';
import QuickSearchUserGroup from 'entities/user_group/quickSearchUserGroup';
import { useCreateUser_to_group, useDeleteUser_to_group, useGetUser_to_groups } from 'queries/user_to_group.query';
import { useNotification } from 'context/NotificationContext';
import { useUpdateCustomer, useSetCustomerRole } from 'queries/customer.query';
import { useUserRoleContext } from 'context/UserRoleContext';
import { useAuth } from 'context/AuthContext';
import { useGetProvinces, useGetWards } from 'queries/geographic.query';

/**
 *   Create upload Modal for Notification
 */

// eslint-disable-next-line import/no-anonymous-default-export

export default function CustomerEditInformation({ onClose, entity }: { onClose: Function; entity?: TypedUser }) {
  /** Địa chính mới */
  const { mutateAsync: getProvinces, data: provinceData, isSuccess: loadCitySuccessfully } = useGetProvinces();
  const { mutateAsync: getWards, data: wardData, isSuccess: loadWardSuccessfully } = useGetWards();

  const { currentUserCan } = useAuth();

  const { addNotification } = useNotification();
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useUpdateCustomer();
  /** user group */
  const [selectedUser_to_group, setSelectedUser_to_group] = useState([]);
  const { data: userToGroupData, isLoading: loadingUserToGroupData } = useGetUser_to_groups(entity.user_id);
  const { mutateAsync: deleteUser_to_group } = useDeleteUser_to_group();
  const { mutateAsync: createUser_to_group } = useCreateUser_to_group();
  const { mutateAsync: changeCustomerRole, isPending } = useSetCustomerRole();

  const onChangeCustomerRoleCallback = useCallback(
    async (new_role: string) => {
      try {
        await changeCustomerRole({
          customer_role: new_role,
          customer_id: entity?.user_id,
        });
      } catch (e) {}
    },
    [entity]
  );

  /** Hiển thị cái group đã selected mà mệt ghê ... */
  useEffect(() => {
    if (userToGroupData) {
      let totalS = [];
      for (let d of userToGroupData.body) {
        totalS.push(d.user_group_id);
      }
      setSelectedUser_to_group(totalS);
    }
  }, [userToGroupData]);
  const deleteUserToGroupCallback = useCallback(async (id) => {
    try {
      await deleteUser_to_group(id);
      addNotification('info', 'Đã xóa người dùng khỏi nhóm');
    } catch (e) {}
  }, []);

  const createUserToGroupCallback = useCallback(
    async (input: string[]) => {
      try {
        for (let user_group_id of input) {
          await createUser_to_group({
            user_group_id: user_group_id,
            user_id: entity?.user_id,
          });
        }
      } catch (e) {}
    },
    [entity]
  );

  /** Lấy user role ra ... */
  const { customerRoleSelection: allRoles } = useUserRoleContext();

  /** Hết code lấy user role ra ... */

  /** end user group */

  const { mutateAsync: addUserToJob } = useAddUserToJob();
  const { smUp } = useBreakpoints();

  const userJobCallback = useCallback(
    (userJobList: string[]) => {
      addUserToJob({
        user_id: entity?.user_id,
        job_id: userJobList ? userJobList.join(',') : null,
      });
    },
    [entity]
  );

  const useFields = {
    user_login: useField<string>({
      value: entity?.user_login || '',
      validates: [
        lengthLessThan(60, 'Không được dài hơn 60 ký tự.'),
        lengthMoreThan(4, 'Không được ngắn hơn 4 ký tự.'),
        (inputValue) => {
          if (inputValue && inputValue.length > 1) {
            if (helpers.isUTF8(inputValue)) {
              return 'Không được dùng mã Unicode trong trường này!';
            }
            if (/^[a-zA-Z0-9_.]+$/.exec(inputValue) === null) {
              return 'Chỉ sử dụng chữ cái, số và dấu chấm';
            }
          }
        },
      ],
    }),

    referrer_code: useField<string>({
      value: entity?.referrer_code || '',
      validates: [
        (inputValue) => {
          if (inputValue && inputValue.length > 0) {
            if (helpers.isUTF8(inputValue)) {
              return 'Không được dùng mã Unicode trong trường này!';
            }
            if (/^[a-zA-Z0-9_.]+$/.exec(inputValue) === null) {
              return 'Chỉ sử dụng chữ cái, số và dấu gạch dưới.';
            }
            if (inputValue.length > 12) {
              return 'Không được dài hơn 12 ký tự.';
            }
            if (inputValue.length < 6) {
              return 'Không được ngắn hơn 6 ký tự.';
            }
          }
        },
      ],
    }),

    user_email: useField<string>({
      value: entity?.user_email || undefined,
      validates: [
        (inputValue) => {
          if (inputValue && !helpers.isEmail(inputValue)) {
            return 'Your email is not valid!';
          }
        },
      ],
    }),

    display_name: useField<string>({
      value: entity?.display_name || undefined,
      validates: [lengthLessThan(60, 'Tên của bạn quá dài!'), lengthMoreThan(2, 'Tên của bạn quá ngắn!')],
    }),

    bio: useField<string>({
      value: entity?.bio || '',
      validates: [lengthLessThan(250, 'Mô tả quá dài!')],
    }),

    user_address: useField<string>({
      value: entity?.user_address || '',
      validates: [lengthLessThan(250, 'Mô tả quá dài!')],
    }),

    user_job: useField<string>({
      value: '',
      validates: [],
    }),

    user_title: useField<string>({
      value: entity?.user_title || '',
      validates: [],
    }),

    user_birthday: useField<string>({
      value: entity?.user_birthday || '',
      validates: [],
    }),

    user_phonenumber: useField<string>({
      value: entity?.user_phonenumber || undefined,
      validates: [
        (inputValue) => {
          if (inputValue) {
            if (!new RegExp('^[0-9]+$', 'g').test(inputValue)) {
              return 'Định dạng số điện thoại không hợp lệ. Chỉ dùng số và dấu cách!';
            }
          }
        },
      ],
    }),

    user_status: useField<number>({
      value: entity?.user_status || 0,
      validates: [],
    }),

    user_verified_email: useField<number>({
      value: entity?.user_verified_email || 0,
      validates: [],
    }),
    user_verified_phone: useField<number>({
      value: entity?.user_verified_phone || 0,
      validates: [],
    }),

    user_address_city: useField<string>({
      value: entity?.user_address_city || '',
      validates: [],
    }),

    user_address_ward: useField<string>({
      value: entity?.user_address_ward || '',
      validates: [],
    }),
  };

  const { fields, submit, dirty } = useForm({
    fields: useFields,
    async onSubmit(values) {
      try {
        await updateEntity({
          user_id: entity?.user_id,
          referrer_code: values.referrer_code,
          user_email: values.user_email,
          user_status: values.user_status,
          user_verified_email: values.user_verified_email,
          user_verified_phone: values.user_verified_phone,
          user_login: values.user_login,
          display_name: values.display_name,
          bio: values.bio,
          user_address: values.user_address,
          user_address_city: values.user_address_city,
          user_address_ward: values.user_address_ward,
          user_phonenumber: values.user_phonenumber,
          user_job: values.user_job,
          user_title: values.user_title,
          user_birthday: values.user_birthday || undefined,
        });
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success', errors: [] };
    },
  });

  useEffect(() => {
    if (updateSuccess) {
      // helpers.resetForm(fields);
      onClose();
      addNotification('info', __('update_successfully'));
    }
  }, [updateSuccess]);

  /**** Địa chỉ mới */

  /**
   * Geographic selectors via API (replacing diachinh.json)
   */
  const [provinceOptions, setProvinceOptions] = useState<{ label: string; value: string }[]>([]);
  const [wardOptions, setWardOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    getProvinces({})
      .then((res) => {
        setProvinceOptions(res.map((p) => ({ label: p.name, value: p.code })));
      })
      .catch();
  }, []);

  // ... trong component của bạn
  useEffect(() => {
    const cityCode = fields.user_address_city.value;
    // Sau đó: user thay đổi city
    setWardOptions([]);
    fields.user_address_ward.onChange('');
    if (cityCode) {
      getWards({ parent_code: cityCode, limit: 200 })
        .then((res) => setWardOptions(res.map((w) => ({ label: w.name, value: w.code }))))
        .catch(/* ... */);
    }
  }, [fields.user_address_city.value]);

  return (
    <>
      <Form onSubmit={submit}>
        <BlockStack gap={{ xs: '800', sm: '400' }}>
          <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
            <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
              <BlockStack gap="400">
                <Text as="h3" variant="headingMd">
                  Tùy chọn
                </Text>
                <Text as="p" variant="bodyMd">
                  Các tùy chọn tài khoản.
                </Text>
              </BlockStack>
            </Box>
            <Card roundedAbove="sm">
              <BlockStack gap="400">
                <FormLayout>
                  <Checkbox
                    label="Cho phép khách đăng nhập"
                    helpText="Nếu tắt, khách hàng này không thể đăng nhập nữa."
                    checked={useFields.user_status.value === 1}
                    onChange={(e) => {
                      useFields.user_status.onChange(Number(e));
                    }}
                  />

                  <Checkbox
                    label="Xét duyệt số điện thoại"
                    disabled={!entity?.user_phonenumber}
                    helpText="Quy trình này thường là tự động, nhưng một vài trường hợp bạn phải xử lý bằng tay tại đây"
                    checked={useFields.user_verified_phone.value === 1}
                    onChange={(e) => {
                      useFields.user_verified_phone.onChange(Number(e));
                    }}
                  />

                  <Checkbox
                    label="Xét duyệt email"
                    disabled={!entity?.user_email}
                    helpText="Quy trình này thường là tự động, nhưng một vài trường hợp bạn phải xử lý bằng tay tại đây"
                    checked={useFields.user_verified_email.value === 1}
                    onChange={(e) => {
                      useFields.user_verified_email.onChange(Number(e));
                    }}
                  />
                </FormLayout>
              </BlockStack>
            </Card>
          </InlineGrid>

          {smUp ? <Divider /> : null}
          {currentUserCan(['view_affiliates']) ? (
            <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
              <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
                <BlockStack gap="400">
                  <Text as="h3" variant="headingMd">
                    Vai trò
                  </Text>
                </BlockStack>
              </Box>
              <Card roundedAbove="sm">
                <BlockStack gap="400">
                  <Select
                    label="Vai trò"
                    disabled={isPending}
                    options={allRoles}
                    onChange={(a) => onChangeCustomerRoleCallback(a)}
                    value={String(entity?.user_role)}
                  />
                  <Text as="p" variant="bodyMd">
                    Khách hàng có nhiều vai trò khác nhau, khi chọn một vai trò mới, người dùng sẽ nhận được thông báo.
                  </Text>
                </BlockStack>
              </Card>
            </InlineGrid>
          ) : null}

          {smUp ? <Divider /> : null}
          <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
            <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
              <BlockStack gap="400">
                <Text as="h3" variant="headingMd">
                  Nhóm người dùng
                </Text>
                <Text as="p" variant="bodyMd">
                  Người dùng / khách hàng có thể tham gia rất nhiều nhóm một lúc, mỗi nhóm có một đặc quyền riêng.
                </Text>
              </BlockStack>
            </Box>
            <Card roundedAbove="sm">
              <InlineStack gap="400" align="start" blockAlign="center">
                {loadingUserToGroupData ? (
                  <SkeletonBodyText />
                ) : (
                  userToGroupData?.body &&
                  userToGroupData?.body?.map((el) => {
                    let { user_group_data } = el;
                    return (
                      <InlineStack gap="200">
                        <Button variant="plain" icon={XIcon} onClick={() => deleteUserToGroupCallback(el.id)}></Button>
                        <Thumbnail
                          size="small"
                          source={helpers.getMediaLink(
                            user_group_data.user_group_thumbnail
                              ? user_group_data.user_group_thumbnail_to_media.media_thumbnail
                                ? user_group_data.user_group_thumbnail_to_media.media_thumbnail['128x128']
                                : user_group_data.user_group_thumbnail_to_media.media_url
                              : null
                          )}
                          alt={''}
                        />
                        <>{user_group_data.user_group_name}</>
                      </InlineStack>
                    );
                  })
                )}
              </InlineStack>
              <br />
              <QuickSearchUserGroup
                displaySelected={false}
                onClose={(EEAA) => createUserToGroupCallback(EEAA)}
                current_user_group_id={selectedUser_to_group}
              />
            </Card>
          </InlineGrid>

          {smUp ? <Divider /> : null}

          <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
            <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
              <BlockStack gap="400">
                <Text as="h3" variant="headingMd">
                  Thông tin chung
                </Text>
                <Text as="p" variant="bodyMd">
                  Càng chi tiết càng tốt.
                </Text>
              </BlockStack>
            </Box>
            <Card roundedAbove="sm">
              <BlockStack gap="400">
                <FormLayout>
                  <TextField
                    autoFocus
                    autoComplete="off"
                    label="Username"
                    helpText={<p>User name không được phép trùng lặp với bất kỳ một tài khoản nào!</p>}
                    {...fields.user_login}
                  />
                  <TextField
                    autoComplete="off"
                    label="Mã giới thiệu"
                    requiredIndicator
                    maxLength={12}
                    helpText={<p>Không nên đổi mã nhiều lần, dẫn tới mã cũ bị vô hiệu. Mã này phải độc nhất.</p>}
                    {...fields.referrer_code}
                  />

                  <TextField
                    label="Tên hiển thị"
                    autoComplete="off"
                    error={fields.display_name.error}
                    value={fields.display_name.value}
                    onChange={(e) => fields.display_name.onChange(helpers.capitalizeWords(e))}
                    connectedLeft={
                      <Select
                        value={useFields.user_title.value}
                        options={[
                          { value: '', label: 'Không set' },
                          { value: 'mr', label: 'Anh' },
                          { value: 'miss', label: 'Cô' },
                          { value: 'mrs', label: 'Chị' },

                          { value: 'madam', label: 'Quý bà' },
                          { value: 'sir', label: 'Quý ông' },
                        ]}
                        onChange={(e) => useFields.user_title.onChange(e)}
                        label={''}
                      />
                    }
                  />

                  <DateTimeInput
                    onDateChange={({ day, month, year }) => {
                      fields.user_birthday.onChange(`${year}-${month}-${day}`);
                    }}
                    label={'Sinh nhật'}
                    initialDate={fields.user_birthday.defaultValue}
                  />
                  <MultiJob onClose={userJobCallback} current_value={entity?.user_to_job} />
                  <TextField
                    maxLength={250}
                    max={250}
                    showCharacterCount={true}
                    autoComplete="off"
                    label="Giới thiệu ngắn"
                    {...fields.bio}
                    multiline={3}
                  />
                </FormLayout>
              </BlockStack>
            </Card>
          </InlineGrid>

          {smUp ? <Divider /> : null}
          <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
            <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
              <BlockStack gap="400">
                <Text as="h3" variant="headingMd">
                  Thông tin liên hệ
                </Text>
                <Text as="p" variant="bodyMd">
                  Càng nhiều thông tin càng tốt
                </Text>
              </BlockStack>
            </Box>
            <Card roundedAbove="sm">
              <BlockStack gap="400">
                <FormLayout>
                  <TextField label="Số điện thoại" autoComplete="off" helpText="Ví dụ: 0906111111" {...fields.user_phonenumber} />

                  <TextField label="Email" autoComplete="off" helpText="Ví dụ: a@gmail.com" {...fields.user_email} />

                  <TextField label="Địa chỉ" autoComplete="off" {...fields.user_address} />

                  <FormLayout.Group condensed>
                    <Select
                      label="Tỉnh/Thành phố"
                      options={[
                        ...[
                          {
                            label: '==Chọn tỉnh thành==',
                            value: '',
                          },
                        ],
                        ...provinceOptions,
                      ]}
                      value={fields.user_address_city.value}
                      onChange={(val) => fields.user_address_city.onChange(val)}
                    />

                    <Select
                      label="Xã/Thị trấn"
                      options={wardOptions}
                      value={fields.user_address_ward.value}
                      onChange={(val) => fields.user_address_ward.onChange(val)}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </BlockStack>
            </Card>
          </InlineGrid>
        </BlockStack>
      </Form>

      {dirty && (
        <ContextualSaveBar
          message="Thay đổi chưa được lưu"
          saveAction={{
            content: __('update_label_button'),
            onAction: () => submit(),
            loading: updating,
          }}
          discardAction={{
            content: 'Thu hồi',
            onAction: () => helpers.resetForm(fields),
          }}
        />
      )}

      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
}

